<div class="container">
  <ion-row class="group-container">
    <ion-col>
      <app-two-column-form
        [isLocationGroupForm]="true"
        [assignedHeaderText]="CONSTANTS.ASSIGNED_GROUPS"
        [assignedData]="assignedGroupData"
        [availableHeaderText]="CONSTANTS.ALL_GROUPS"
        [availableData]="allGroups"
        (canSubmitForm)="handleUpdateSubmit($event)"
        (updateAssignedValues)="handleUpdateAssignedValues($event)"
      ></app-two-column-form>
    </ion-col>
  </ion-row>

  <!-- footer -->
  <ion-row class="group-footer">
    <ion-col size="11">
      <app-footer-action-bar
        [edit]="edit"
        [btnEnabled]="isGroupChanged"
        [resetBtnEnabled]="isGroupChanged"
        (submitBtnClick)="onSubmit()"
        (resetBtnClick)="resetGroups()"
      ></app-footer-action-bar>
    </ion-col>
  </ion-row>
</div>
